import React, { useEffect, useState, useRef } from "react";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import { useDispatch, useSelector } from "react-redux";
import OwnerRegisteraion from "./OwnerRegisteration";
import PackageSelectionDesign from "./PackageSelection";
import OwnersDataReview from "./OwnerDataReview";
import InstituteSubmissionScreen from "./SubmissionScreen";
import InstituteTermAndConditions from "./TermsAndConditions";
import { RegisterNewInstituteA, CheckoutPaymentFailureA, CheckoutPaymentSuccessA, RegisterNewInstituteOwnersdataA, RegisterPaypalNewInstituteOwnersdataA, SavingInstituteFormInJsonA } from "../../Actions/UserA";
import PaymentCheckout from "./PaymentCheckout";
import { useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { GetInstitutePackagesDetails } from "../../Actions/StudentA";
import ReuseablePopup from "../../Components/ReuseablePopups/ReuseablePopup";
import { ResetLoginSignUp } from "../../Actions/ToggleSignupA";
import SurePopupImg from "./Assets/SurePopup.png";
import errorMessageImage from "./Assets/errorMessage.png";

const stripePromise = loadStripe("pk_test_51R43UFD3cD5p3COSu4hXSozwMkHBbPple59QTIm1kg1O5bgGsJFPrg1cB4nK4vP0twcY7ZawmNaMaLtkbIMMbWS200udy4SIBx");

const PartnerOwnerRegisteration = () => {
    const { error, loading } = useSelector((Store) => Store.LoginSignupReducer);
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const [openSignupScreen, setOpenSignupScreen] = useState("OwnerRegisteration");
    const { packageId, instituteId } = useParams(); // Get packageId from the URL

    const { InstitutePackagesData } = useSelector((Store) => Store.StudentReducer);
    console.log("InstitutePackagesData is:",InstitutePackagesData)

    const [InstituteData, setInstituteData] = useState({
      ownersData: {
        ownerIdFront: null,
        ownerIdBack: null,
        ownerPicture: null,
        ownerSignatureImage: null,
        contactNumber: "",
        emergencyNumber: "",
        emergencyEmail: "",
        FirstName: "",
        LastName: "",
        email: "",
        postalCode: "",
        country: "",
        province: "",
        city: "",
        Address: "",
      },
      package: {}, // Store selected package details
      ownersSignature:"",
      agreedTerms: {}, // <--- Add this
      agreedConfirmation:"",
      paymentInfo: {
        paymentMethod: "", // e.g., "paypal"
        paymentSuccessful: false, // can be set after PayPal confirms
        agreedToTerms: false,
        autoDeduction: false,
        grandTotal: 0,
        paypalOrderId:"", 
        cardDetails: {   // ✅ Add this section
            CardBrand: "",
            CardExpMonth: "",
            CardExpYear: "",
            CardLast4: "",
            CardPostalCode: "",
          }
      }
  });
  const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");

  const initialInstituteDataRef = useRef(JSON.stringify(InstituteData));

  const hasFormChanged = () => {
    return JSON.stringify(InstituteData) !== initialInstituteDataRef.current;
  };

  const Dispatch = useDispatch();

    useEffect(() => {
        Dispatch(GetInstitutePackagesDetails())
    }, []);

    // const handleSubmit = async (updatedPaymentInfo) => {
    // const formData = new FormData();

    // // Convert nested objects to JSON (without files)
    // const ownersDataWithoutFiles = { ...InstituteData.ownersData };

    // // Remove file objects before converting to JSON
    // Object.keys(ownersDataWithoutFiles).forEach(key => {
    //     if (ownersDataWithoutFiles[key]?.file) delete ownersDataWithoutFiles[key];
    // });

    // formData.append("ownersData", JSON.stringify(ownersDataWithoutFiles));
    // formData.append("package", JSON.stringify(InstituteData.package));
    // // formData.append("paymentInfo", JSON.stringify(InstituteData.paymentInfo));
    // formData.append("paymentInfo", JSON.stringify(updatedPaymentInfo || InstituteData.paymentInfo));
    // formData.append("ownersSignature", JSON.stringify(InstituteData.ownersSignature));

    // // Append Files (Use `.file` instead of preview URL)
    // if (InstituteData.ownersData.ownerIdFront?.file) formData.append("OwnerIdFront", InstituteData.ownersData.ownerIdFront.file);
    // if (InstituteData.ownersData.ownerIdBack?.file) formData.append("OwnerIdBack", InstituteData.ownersData.ownerIdBack.file);
    // if (InstituteData.ownersData.ownerPicture?.file) formData.append("OwnerPicture", InstituteData.ownersData.ownerPicture.file);
    // if (InstituteData.ownersData.ownerSignatureImage?.file) formData.append("OwnerSignatureImage", InstituteData.ownersData.ownerSignatureImage.file);

    // // Dispatch API Call
    //   Dispatch(RegisterNewInstituteOwnersdataA(formData, instituteId, () => {
    //       console.log("Institute Registered Successfully!");
    //       setOpenSignupScreen("SubmissionScreen");
    //   },
    //   (errorMessage) => {
    //     // error callback — show popup here
    //   }));
    // };
      

    const handleSubmit = (updatedPaymentInfo) => {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
    
            // Convert nested objects to JSON (without files)
            const ownersDataWithoutFiles = { ...InstituteData.ownersData };
            Object.keys(ownersDataWithoutFiles).forEach(key => {
                if (ownersDataWithoutFiles[key]?.file) delete ownersDataWithoutFiles[key];
            });
    
            formData.append("ownersData", JSON.stringify(ownersDataWithoutFiles));
            formData.append("package", JSON.stringify(InstituteData.package));
            formData.append("paymentInfo", JSON.stringify(updatedPaymentInfo || InstituteData.paymentInfo));
            formData.append("ownersSignature", JSON.stringify(InstituteData.ownersSignature));
    
            // Append files
            if (InstituteData.ownersData.ownerIdFront?.file) formData.append("OwnerIdFront", InstituteData.ownersData.ownerIdFront.file);
            if (InstituteData.ownersData.ownerIdBack?.file) formData.append("OwnerIdBack", InstituteData.ownersData.ownerIdBack.file);
            if (InstituteData.ownersData.ownerPicture?.file) formData.append("OwnerPicture", InstituteData.ownersData.ownerPicture.file);
            if (InstituteData.ownersData.ownerSignatureImage?.file) formData.append("OwnerSignatureImage", InstituteData.ownersData.ownerSignatureImage.file);
    
            // Dispatch API
            // Dispatch(RegisterNewInstituteOwnersdataA(formData, instituteId,
            //     () => {
            //         console.log("Institute Registered Successfully!");
            //         // setOpenSignupScreen("SubmissionScreen");
            //         resolve(); // success
            //     },
            //     (errorMessage) => {
            //         reject(new Error(errorMessage)); // failure
            //     }
            // ));
             // ✅ Pass in a callback that resolves or rejects
            Dispatch(RegisterNewInstituteOwnersdataA(formData, instituteId, 
                () => resolve(),
                (errorMessage) => reject(new Error(errorMessage))
            ));
        });
    };

    const handlePaypalSubmit = (updatedPaymentInfo) => {
            const formData = new FormData();
    
            // Convert nested objects to JSON (without files)
            const ownersDataWithoutFiles = { ...InstituteData.ownersData };
            Object.keys(ownersDataWithoutFiles).forEach(key => {
                if (ownersDataWithoutFiles[key]?.file) delete ownersDataWithoutFiles[key];
            });
    
            formData.append("ownersData", JSON.stringify(ownersDataWithoutFiles));
            formData.append("package", JSON.stringify(InstituteData.package));
            formData.append("paymentInfo", JSON.stringify(updatedPaymentInfo || InstituteData.paymentInfo));
            formData.append("ownersSignature", JSON.stringify(InstituteData.ownersSignature));
    
            // Append files
            if (InstituteData.ownersData.ownerIdFront?.file) formData.append("OwnerIdFront", InstituteData.ownersData.ownerIdFront.file);
            if (InstituteData.ownersData.ownerIdBack?.file) formData.append("OwnerIdBack", InstituteData.ownersData.ownerIdBack.file);
            if (InstituteData.ownersData.ownerPicture?.file) formData.append("OwnerPicture", InstituteData.ownersData.ownerPicture.file);
            if (InstituteData.ownersData.ownerSignatureImage?.file) formData.append("OwnerSignatureImage", InstituteData.ownersData.ownerSignatureImage.file);
    
            // Dispatch API
            Dispatch(RegisterPaypalNewInstituteOwnersdataA(formData, instituteId,
                () => {
                    console.log("Institute Registered Successfully!");
                   // Use the PayPal order ID directly from formData or updatedPaymentInfo
                    // const paypalOrderId = formData.get("paymentInfo") 
                    // ? JSON.parse(formData.get("paymentInfo")).paypalOrderId 
                    // : "";

                    // Extract PayPal order ID from formData
                    const paymentInfo = formData.get("paymentInfo");
                    const parsedPaymentInfo = paymentInfo ? JSON.parse(paymentInfo) : {};
                    const paypalOrderId = parsedPaymentInfo.paypalOrderId || "";

                    // Construct UserData object to send to backend
                    const userData = {
                    paypalOrderId: paypalOrderId, // if you're still using the ID as a key
                    paymentType: "paypal"
                    };
                    Dispatch(CheckoutPaymentSuccessA(userData, instituteId,
                        () => {
                            console.log("Institute Registered Successfully!");
                            setOpenSignupScreen("SubmissionScreen");
                        },
                        (errorMessage) => {
                            //alert(errorMessage); // show error
                            setErrorMessageText(errorMessage)
                            setIsUpdationFailedPopup(true)
                        }
                    ));
                    // setOpenSignupScreen("SubmissionScreen");
                },
                (errorMessage) => {
                    Dispatch(SavingInstituteFormInJsonA(formData, instituteId))
                    Dispatch(CheckoutPaymentFailureA(errorMessage, instituteId));
                    // alert(errorMessage); // show error
                    setErrorMessageText(errorMessage)
                    setIsUpdationFailedPopup(true)
                }
            ));
             // Pass in a callback that resolves or rejects
            // Dispatch(RegisterNewInstituteOwnersdataA(formData, instituteId, 
            //     () => resolve(),
            //     (errorMessage) => reject(new Error(errorMessage))
            // ));
    };
    
    const [showPopup, setShowPopup] = useState(false);

    const handleDiscardClick = () => {
        const isLocalhost = window.location.hostname === "localhost";
        window.location.href = isLocalhost
          ? "http://localhost:3000"
          : "https://vehiclelearning.com/";
      };
      

    return !loading ? (
        <Elements stripe={stripePromise} >
            <div
                className={`LightBg partner-bg`} // Conditional class
                style={{
                    backgroundImage: "url('/assets/partnerbg.png')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div
                    className="MainParent bgGradient"
                >
                    <div
                        className="FormParent bg-transparent md:bg-transparent"
                        style={{ backgroundColor: "transparent" }}
                    >
                        <div
                        style={{
                        // width: ["PackageSelection", "SubmissionScreen"].includes(openSignupScreen) ? "100%" : "100% lg:80%",
                        // width: ["PackageSelection", "SubmissionScreen"].includes(openSignupScreen)
                        //     ? "100%"
                        //     : openSignupScreen === "OwnerDataReview"
                        //         ? "100% lg:80%"
                        //         : "100% lg:80%",
                        // backgroundColor: "white",
                        backgroundColor:  ["PackageSelection", "PaymentCheckout", "SubmissionScreen"].includes(openSignupScreen) ? "#F4F5F9" : "white",
                        // paddingTop: "2.5rem", // equivalent to pt-10
                        paddingBottom: openSignupScreen === "PackageSelection" ? "1rem" : "4rem", // md:pb-4, xl:pb-8
                        display: "flex",
                        alignItems: "flex-start",
                        height: "fit-content",
                        overflowX: "hidden",
                        position: "relative",
                        borderRadius: openSignupScreen === "PackageSelection" ? "lg:21px" : "0",
                        // marginTop: "100px",
                        }}
                        // className="md:bg-white md:pt-0"
                        className={`w-full ${openSignupScreen === "OwnerDataReview" ? "lg:w-[80%]" : "lg:w-[100%]"}`}
                        >


        <div className="absolute top-2 right-2 "
            // onClick={() => setShowPopup(true)}
            onClick={() => {
                if (hasFormChanged()) {
                setShowPopup(true); // Show discard confirmation
                } else {
                handleDiscardClick(); // Immediately close if no changes
                }
            }}
            >
            <img
              className="absolute right-3 top-[6px] cursor-pointer w-[30px] h-[30px]"
              src={require("./Assets/InstituteCross.svg").default}
              alt="image"
            />
          </div>

          {showPopup && (
            <ReuseablePopup
                setShowPopup={setShowPopup}
                heading="Are you sure?"
                text="Are you sure you want to close? Any changes you've made will not be saved."
                btnText="Discard "
                onClick={handleDiscardClick}
                imageSrc={SurePopupImg} // ✅ Dynamic image source
                />
        )}

        {isUpdationFailedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdationFailedPopup}
                heading="Oops!"
                text={errorMessageText}
                btnText="Back"
                onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}
                        
                        {openSignupScreen === "OwnerRegisteration" && (
                            <OwnerRegisteraion
                            InstituteData={InstituteData}
                            setInstituteData={setInstituteData}
                            setOpenSignupScreen={setOpenSignupScreen} />
                        )}

                        {openSignupScreen === "PackageSelection" && (
                            <PackageSelectionDesign
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData}
                            setInstituteData={setInstituteData}
                            instituteId={instituteId}
                            InstitutePackagesData={InstitutePackagesData}
                            />
                        )}

                        {openSignupScreen === "TermAndCondition" && (
                            <InstituteTermAndConditions
                            setOpenSignupScreen={setOpenSignupScreen}
                            setInstituteData={setInstituteData}
                            InstituteData={InstituteData} />
                        )}


                        {openSignupScreen === "OwnerDataReview" && (
                            <OwnersDataReview
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData}
                            handleSubmit={handleSubmit} />
                        )}

                        {openSignupScreen === "PaymentCheckout" && (
                            <PaymentCheckout
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData}
                            setInstituteData={setInstituteData}
                            handleSubmit={handlePaypalSubmit}
                            InstitutePackagesData={InstitutePackagesData}
                            instituteId={instituteId}
                            />
                        )}

                        {openSignupScreen === "SubmissionScreen" && (
                            <InstituteSubmissionScreen
                            setOpenSignupScreen={setOpenSignupScreen}
                            InstituteData={InstituteData}
                            instituteId={instituteId} />
                        )}
                    
                        </div>
                    </div>
                </div>
            </div>
        </Elements>
      ) : (
        <LoadingSpinner />
      );
}

export default PartnerOwnerRegisteration;
